/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.ComponentKeywordsUpload";
        class ComponentKeywordsUpload extends Widgets.ComponentKeywordsBase {
            constructor(core, container, parent) {
                super(core, container, parent);
                this._cacheUpdated = () => {
                    if (this._core.OBHelper.KeywordTypesLoaded && this._core.OBHelper.UploadDocumentTypesLoaded)
                        this._cacheReady = true;
                };
                this._sanityCheckRequest = (request) => {
                    if (!request.hasOwnProperty('DocTypes') || (request.DocTypes == null) || (request.DocTypes.length == 0))
                        return false;
                    return true;
                };
                this._servicePendingRequest = () => {
                    this._log.info("ComponentKeywordsUpload._servicePendingRequest()");
                    // Nothing to do if nothing pending
                    if (!this._requestPending)
                        return;
                    // Bump pending request to active status
                    this._requestActive = this._requestPending;
                    if (!this.ActiveRequest.hasOwnProperty('PrefillRecords') || (this.ActiveRequest.PrefillRecords == null))
                        this.ActiveRequest.PrefillRecords = [];
                    this._requestPending = null;
                    this._listRoot.innerHTML = '';
                    this._setUserKeywordPrivilege();
                    this._buildUI(this._mergeDocTypes());
                };
                this._setUserKeywordPrivilege = () => {
                    this._log.info('ComponentKeywordsUpload::_setUserKeywordPrivilege');
                    // Use LEAST permissive option
                    this._userCanAccessRestrictedKeys = false;
                    if (this.ActiveRequest.hasOwnProperty('DefaultDocType') && this.ActiveRequest.DefaultDocType) {
                        let dt = this._core.OBHelper.UploadDocumentTypeMap[this.ActiveRequest.DefaultDocType];
                        if (dt && dt.hasOwnProperty('Privileges') && (dt.Privileges)) {
                            // If we don't have access on the default doc type, jump out and remain false
                            if (dt.Privileges.AccessRestrictedKeywords)
                                this._userCanAccessRestrictedKeys = true;
                            else
                                return;
                        }
                    }
                    // If we get here, either there was no default, or it has restricted access enabled for this user
                    if (this.ActiveRequest.hasOwnProperty('DocTypes') && this.ActiveRequest.DocTypes) {
                        this._log.trace('Checking document types for Access Restricted privileges');
                        let restrictedAccess = true;
                        this.ActiveRequest.DocTypes.forEach(dtName => {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`Checking doc type '${dtName}'`);
                            }
                            let dt = this._core.OBHelper.UploadDocumentTypeMap[dtName];
                            if (dt && dt.hasOwnProperty('Privileges') && (dt.Privileges)) {
                                if (!dt.Privileges.AccessRestrictedKeywords)
                                    restrictedAccess = false;
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`Doc type '${dtName}' has AccessRestrictedKeywords = ${dt.Privileges.AccessRestrictedKeywords}`);
                                }
                            }
                        });
                        this._userCanAccessRestrictedKeys = restrictedAccess;
                    }
                };
                // Merges mutiple doc types into a single pseudo-type in order to gerate a list of common keywords
                this._mergeDocTypes = () => {
                    this._log.info("ComponentKeywordsUpload._mergeDocTypes()");
                    // We can bypass the whole operation in a couple of circumstances
                    if (this.ActiveRequest.hasOwnProperty('DefaultDocType')
                        && (this.ActiveRequest.DefaultDocType)
                        && (this._core.OBHelper.UploadDocumentTypeNames.indexOf(this.ActiveRequest.DefaultDocType) > -1)) {
                        this._log.trace("ComponentKeywordsUpload._mergeDocTypes() returning default doc type.");
                        return this._core.OBHelper.UploadDocumentTypeMap[this.ActiveRequest.DefaultDocType];
                    }
                    // Need something to return
                    let mergedType = {
                        Id: -1,
                        Name: "Pseudo-Type",
                        TranslatedName: "Pseudo-Type",
                        KeywordRecords: []
                    };
                    if (!this.ActiveRequest.hasOwnProperty('DocTypes') || (this.ActiveRequest.DocTypes == null) || (this.ActiveRequest.DocTypes.length == 0)) {
                        this._log.trace("_mergeDocTypes() no doc types passed, returning empty pseudo-type.");
                        return mergedType;
                    }
                    // Need to filter our doc types to ensure they are genuine and available
                    let filteredDocTypes = [];
                    this.ActiveRequest.DocTypes.forEach(dtName => { if (this._core.OBHelper.UploadDocumentTypeNames.indexOf(dtName) > -1)
                        filteredDocTypes.push(dtName); });
                    if (filteredDocTypes.length == 0) {
                        this._log.trace("_mergeDocTypes() all doc types filtered, returning empty pseudo-type.");
                        return mergedType;
                    }
                    if (filteredDocTypes.length == 1) {
                        this._log.trace("_mergeDocTypes() filtered to single doc type - returning.");
                        return this._core.OBHelper.UploadDocumentTypeMap[filteredDocTypes[0]];
                    }
                    // Need to do the full merge - start with doc type 1
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`ComponentKeywordsUpload._mergeDocTypes() filtered to ${filteredDocTypes.length} doc types - merging.`);
                        this._log.trace(`merging doc type ${filteredDocTypes[0]}`);
                    }
                    let filteredRecordNames = [];
                    let filteredStandaloneKeysNames = [];
                    this._core.OBHelper.UploadDocumentTypeMap[filteredDocTypes[0]].KeywordRecords.forEach(keyRecordDef => {
                        if (keyRecordDef.Type == 'StandAlone')
                            keyRecordDef.KeywordTypes.forEach(keyType => { filteredStandaloneKeysNames.push(keyType.Name); });
                        else
                            filteredRecordNames.push(keyRecordDef.Name);
                    });
                    if (this._log.isTraceEnabled) {
                        this._log.trace(`Starting filtering with keyword names: ${filteredStandaloneKeysNames}`);
                        this._log.trace(`Starting filtering with record names: ${filteredRecordNames}`);
                    }
                    // Any records which aren't standalone can be kept/dismissed at the group level
                    for (let i = 1; i < filteredDocTypes.length; i++) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`merging doc type ${filteredDocTypes[i]}`);
                        }
                        let filterOutputGroups = [];
                        let filterOutputKeys = [];
                        this._core.OBHelper.UploadDocumentTypeMap[filteredDocTypes[i]].KeywordRecords.forEach(keyRecordDef => {
                            if (keyRecordDef.Type == 'StandAlone') {
                                keyRecordDef.KeywordTypes.forEach(testType => {
                                    if (filteredStandaloneKeysNames.indexOf(testType.Name) > -1)
                                        filterOutputKeys.push(testType.Name);
                                });
                            }
                            else if (filteredRecordNames.indexOf(keyRecordDef.Name) > -1)
                                filterOutputGroups.push(keyRecordDef.Name);
                        });
                        // Copy filters back over root list
                        filteredStandaloneKeysNames = filterOutputKeys;
                        filteredRecordNames = filterOutputGroups;
                        if (this._log.isTraceEnabled) {
                            this._log.trace(`Filter iteration exiting with keyword names: ${filteredStandaloneKeysNames}`);
                            this._log.trace(`Filter iteration exiting  with record names: ${filteredRecordNames}`);
                        }
                    }
                    // Insert any remaining non-standalone records
                    if (filteredStandaloneKeysNames.length > 0) {
                        this._log.trace('Creating standalone record against pseudo-doc type');
                        let saRecord = this._createStandaloneRecordType();
                        filteredStandaloneKeysNames.forEach(ktName => { saRecord.KeywordTypes.push(this._core.OBHelper.KeywordTypeMap[ktName]); });
                        mergedType.KeywordRecords.push(saRecord);
                    }
                    filteredRecordNames.forEach(recordName => { mergedType.KeywordRecords.push(this._core.OBHelper.KeywordRecordTypeMap[recordName]); });
                    return mergedType;
                };
                this._checkGroupRemovalAllowed = (groupWrapper) => {
                    this._log.info('ComponentKeywordsUpload::_checkGroupRemovalAllowed');
                    let encountered = 0;
                    for (let id in this._groupMap) {
                        if (this._groupMap[id].RecordType.Name == groupWrapper.RecordType.Name)
                            encountered++;
                    }
                    if (encountered > 1)
                        return true;
                    else
                        return false;
                };
                this._log = core.Logging.getLogger(LOG_CATEGORY);
                this._core.OBHelper.LoadUploadDocumentTypes(this._cacheUpdated);
            }
            get ActiveRequest() {
                return this._requestActive;
            }
            // When we build the UI, we can check the passed for each group/key added to see if it needs to be populated
            _buildUI(docType) {
                this._log.info("ComponentKeywordsUpload._buildUI()");
                this._groupMap = {};
                // Get a copy of the record types (so we can modify) and sort
                let typeRecs = JSON.parse(JSON.stringify(docType.KeywordRecords));
                typeRecs = typeRecs.sort((r1, r2) => { return Widgets.ComponentKeywordsBase._sortMap[r1.Type] - Widgets.ComponentKeywordsBase._sortMap[r2.Type]; });
                // Insert standalone if we need one...
                if (!this.ActiveRequest.SuppressDocDate) {
                    this._log.trace('Inserting standalone record for document date');
                    if ((typeRecs.length == 0) || (typeRecs[0].Type != 'StandAlone'))
                        typeRecs.unshift(this._createStandaloneRecordType());
                    // ...because we need a doc date editor
                    typeRecs[0].KeywordTypes.unshift(this._core.OBHelper.KeywordTypeMap[">>DocumentDate"]);
                }
                // Insert document-type level autofill into type record definition
                let afks = (docType.hasOwnProperty('AutoFillKeywordSet') && (docType.AutoFillKeywordSet != null)) ? docType.AutoFillKeywordSet : null;
                typeRecs.forEach(typeRec => {
                    typeRec.KeywordTypes.forEach(kt => { this._log.trace(`KT: ${kt.Name}`); });
                    // Skip to next iteration if we are explicitly not included or excluded
                    if (this._requestActive.IncludeGroups.length > 0) {
                        if (this._requestActive.IncludeGroups.indexOf(typeRec.Name) == -1)
                            return;
                    }
                    else if (this._requestActive.ExcludeGroups.length > 0) {
                        if (this._requestActive.ExcludeGroups.indexOf(typeRec.Name) > -1)
                            return;
                        if ((this._requestActive.ExcludeGroups.indexOf('*') > -1) && (typeRec.Type == 'MultiInstance'))
                            return;
                    }
                    // Skip to next iteration if no keywords in this group type
                    if (!WPTNamespace.MetadataEditors.KeywordGroupWrapper.HasKeywords(typeRec, this._requestActive.IncludeKeywords, this._requestActive.ExcludeKeywords))
                        return;
                    // Tag any AFKS primary with doc type AFKS - so doc type set overrides keyword type set if both have an autofill
                    if (afks)
                        typeRec.KeywordTypes.forEach(kwt => { if (kwt.Name == afks.PrimaryKeyword.Name)
                            kwt.AutofillKeywordSetId = afks.Id; });
                    let suppressHeading = ((typeRecs.length == 1) && (typeRec.Type == "StandAlone")) ? true : false;
                    // We only want to apply include/exclude keywords for the SIKG/Stanalone types
                    let includes = (typeRec.Type == 'MultiInstance') ? null : this._requestActive.IncludeKeywords;
                    let excludes = (typeRec.Type == 'MultiInstance') ? null : this._requestActive.ExcludeKeywords;
                    // Loop against any actual instances passed across
                    let realRecs = this.ActiveRequest.PrefillRecords.filter(rec => (rec.Name == typeRec.Name));
                    if (realRecs.length > 0) {
                        realRecs.forEach(realRec => {
                            let id = Widgets.ComponentKeywordsBase.CounterString;
                            let recordWrapper = new WPTNamespace.MetadataEditors.KeywordGroupWrapper(this._core, this._form, this._listRoot, id, typeRec, realRec, WPTNamespace.MetadataEditors.KeywordEditMode.UPLOAD, this._userCanAccessRestrictedKeys, suppressHeading, this.ActiveRequest.SimpleEditors, includes, excludes);
                            recordWrapper.AddCallback = this._groupAddCallback;
                            recordWrapper.RemoveCallback = this._groupRemoveCallback;
                            recordWrapper.CheckForRemoveCallback = this._checkGroupRemovalAllowed;
                            this._groupMap[id] = recordWrapper;
                        });
                    }
                    else {
                        let id = Widgets.ComponentKeywordsBase.CounterString;
                        let recordWrapper = new WPTNamespace.MetadataEditors.KeywordGroupWrapper(this._core, this._form, this._listRoot, id, typeRec, null, WPTNamespace.MetadataEditors.KeywordEditMode.UPLOAD, this._userCanAccessRestrictedKeys, suppressHeading, this.ActiveRequest.SimpleEditors, includes, excludes);
                        recordWrapper.AddCallback = this._groupAddCallback;
                        recordWrapper.RemoveCallback = this._groupRemoveCallback;
                        recordWrapper.CheckForRemoveCallback = this._checkGroupRemovalAllowed;
                        this._groupMap[id] = recordWrapper;
                    }
                });
                // Callback if we are showing nothing
                if ((Object.keys(this._groupMap).length == 0) && (this.NoKeysToDisplayCallback))
                    this.NoKeysToDisplayCallback();
            }
        }
        Widgets.ComponentKeywordsUpload = ComponentKeywordsUpload;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
